import { StarFilled, StarOutlined } from '@ant-design/icons'
import { useMutation } from '@apollo/client'
import { Button } from 'antd'
import { memo } from 'react'
import { DEMANDE_UPDATE } from '../../apollo/mutation/demande.mutation'
import { COLOR } from '../../constants'
import { D4_Demande, D4_Demande_Set_Input, D4_Fn_View_Demande } from '../../types'

const DemandeEpingleCell = memo(({ item }: { item: D4_Fn_View_Demande }) => {
  const [updateDemande, { loading }] = useMutation<{ demande: D4_Demande }, { id: number; data: D4_Demande_Set_Input }>(
    DEMANDE_UPDATE,
    {
      update: (cache, { data }) => {
        cache.modify({
          id: cache.identify({ id: data?.demande.id, __typename: 'd4_fn_view_demande' }),
          fields: {
            epingle() {
              return data?.demande.epingle
            },
          },
        })
      },
    }
  )

  return (
    <Button
      icon={item.epingle ? <StarFilled style={{ color: COLOR.yellow }} /> : <StarOutlined />}
      type="text"
      size="small"
      disabled={loading}
      loading={loading}
      onClick={(e) => {
        e.stopPropagation()
        updateDemande({
          variables: { id: item.id, data: { epingle: !item.epingle } },
        })
      }}
    />
  )
})

export default DemandeEpingleCell
